import React from 'react';
import './App.css';
import { SnackbarProvider } from 'notistack';
import BasicRoute from "./router";
import { ThemeProvider } from '@material-ui/styles';
import { createMuiTheme } from '@material-ui/core';
import { I18nextProvider } from 'react-i18next';
import i18nService from './i18n';
import './i18n';
import { WebsocketClient } from './websocket/module';
import { StateManager } from './redux/stateManager';
import { isMobileOnly } from 'react-device-detect';
import Iframe from 'react-iframe'
import _ from 'lodash';
import 'react-photo-view/dist/index.css';
import Store from './redux/store';
import moment from 'moment-timezone';
import { DefaultRequest } from './requests/default.request';

class App extends React.Component<Props, State> {

    constructor(props: Props) {
        super(props)
    }

    public state: State = {
    }

    // *********************
    // Life Cycle Function
    // *********************
    UNSAFE_componentWillMount() {
        this.init();
    }

    // *********************
    // Default Function
    // *********************
    /**
     * 获取服务器地址
     * @example
     * api - HTTPS_HTTP_SERVER_URL: 'http://192.168.3.110:3000',
     * WS - WEBSOCKET_SERVER_URL: 'http://192.168.3.110:3002'
     */
    async init() {
        let URL = `${window.top?.location?.protocol}` + '//' + `${window.top?.location?.hostname}`
        const GlobalConfig = {
            HTTPS_HTTP_SERVER_URL: URL,
            WEBSOCKET_SERVER_URL: URL
        }
        Store.dispatch({
            type: 'SET_CACHING',
            path: 'GlobalConfig',
            value: GlobalConfig
        })
        Store.dispatch({
            type: 'SET_CACHING',
            path: 'serverUrl',
            value: GlobalConfig.HTTPS_HTTP_SERVER_URL
        })
        i18nService.changeLanguage(StateManager.getFromCache('language'))
        // 初始化 Websocket
        WebsocketClient.init();
        // 连接房间
        WebsocketClient.connect();
        const testPing = await DefaultRequest.testServer();
        if (testPing.timezone) {
            moment.tz.setDefault(testPing.timezone);
        }
    }
    // *********************
    // View
    // *********************

    render() {
        const theme = createMuiTheme({
            palette: {
                type: 'dark',
                primary: {
                    main: '#00CCCC'
                },
                secondary: {
                    main: '#5b73b2'
                }
            }
        });
        return (
            (isMobileOnly || window.self !== window.top) || !_.get(window.top, 'location.href') ?
                <ThemeProvider theme={theme}>
                    <I18nextProvider i18n={i18nService}>
                        <SnackbarProvider
                            maxSnack={6}
                            classes={{
                                containerAnchorOriginTopLeft: 'snackbar',
                            }}
                        >
                            <div className="App">
                                <header className="App-header">
                                    <BasicRoute />
                                </header>
                            </div>
                        </SnackbarProvider>
                    </I18nextProvider>
                </ThemeProvider> :
                <div className='laytoutCenter'>
                    <Iframe
                        url={_.get(window.top, 'location.href')}
                        // url={PREURI}
                        id='myId'
                        className='ignore_iframe'
                        frameBorder={0}
                        display='block' />
                </div>
        )
    }
}
export default App

// *********************
// State & Props
// *********************

type State = {}

type Props = {}
